// Which font can draw this language's characters.
//
// THE FAILURE THIS EXISTS FOR. --han was one Simplified-Chinese-first stack -- PingFang SC,
// Hiragino Sans GB, Noto Sans CJK SC, Source Han Sans SC, Microsoft YaHei -- used by nineteen
// rules, including the one that sets the headword on a card. PingFang SC CONTAINS Japanese kanji,
// so the browser never falls through to a Japanese face: it draws them, in their Chinese shapes,
// and the Japanese course taught 直 骨 今 令 with the wrong strokes on the card the learner is
// studying from. A missing glyph is loud. A present, wrong one is silent, and this app exists to
// argue with exactly that kind of near enough.
//
// Shared because two consumers need the same answer in different forms: the stylesheet declares
// --han per language, and the wallpaper has to write a stack INTO an SVG data URI, which is its own
// document and cannot see a custom property.

/** The Han-capable stacks, by the language whose shapes they draw. */
export const FACES: Record<string, string> = {
  zh: "'PingFang SC','Hiragino Sans GB','Noto Sans CJK SC','Source Han Sans SC','Microsoft YaHei',system-ui,sans-serif",
  ja: "'Hiragino Sans','Hiragino Kaku Gothic ProN','Yu Gothic','Yu Gothic UI','Noto Sans JP','Source Han Sans JP','Meiryo',system-ui,sans-serif",
};

/** The default: let the platform choose, which for a Latin script is the right answer anyway. */
export const PLAIN_FACE = 'system-ui,sans-serif';

/**
 * A stack that can draw `code`, matched on the primary subtag.
 *
 * zh-TW and zh-CN want the same faces here -- the difference between them is which characters the
 * corpus holds, not which font draws them. A language with nothing special to ask for gets the
 * platform's own.
 */
export function faceFor(code: string): string {
  return FACES[code.split('-')[0] ?? ''] ?? PLAIN_FACE;
}
